import produce from 'immer';
import { SET_CLEAR_CUSTOMER } from 'containers/WorkQueue/constants';
import { SET_STATUS_HISTORY, SET_STATUS_CODE_TYPES } from './constants';

export const initialState = {
  statusHistory: {},
  statusCodeList: [],
};

const reducer = (state = initialState, { type, payload }: any) =>
  produce(state, (draft: any) => {
    switch (type) {
      case SET_STATUS_HISTORY:
        draft.statusHistory = payload;
        break;
      case SET_CLEAR_CUSTOMER:
        draft.statusHistory = initialState.statusHistory;
        break;
      case SET_STATUS_CODE_TYPES:
        draft.statusCodeList = payload;
        break;
      default: {
        break;
      }
    }
  });

export default reducer;
